export default (path: string): string => {
    return require(`@/assets/${path}`);
}
